import React, { Component } from 'react'
import { Modal } from 'react-bootstrap'
import i18n from 'live/services/i18n'

interface IProps{
    onClick: () => void 
    msg: string
    title: string 
    show: boolean

}

export default function Success ({ onClick, msg, title, show = true }:IProps) {
    return (
            <Modal dialogClassName="modal-ok" show={show}>
                <Modal.Header>
                    <Modal.Title>{title || i18n('Success')}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div
                        style={{ whiteSpace: 'pre-line', wordWrap: 'break-word' }}
                        dangerouslySetInnerHTML={{ __html: msg || i18n('Data imported!') }}
                    />
                </Modal.Body>

                <Modal.Footer>
                    <button className="btn btn-primary" onClick={onClick}>
                        OK
                    </button>
                </Modal.Footer>
            </Modal>
        )
}
